import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'asap-users-avatar',
    templateUrl: './avatar.html',
    styleUrls: ['./avatar.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'asap-users-avatar',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UsersAvatarComponent {

    @Input() firstName: string;
    @Input() lastName: string;
    @Input() icon: string;
}